import { render, staticRenderFns } from "./SWarning.vue?vue&type=template&id=ad0d64d8&scoped=true&functional=true&"
import script from "./SWarning.vue?vue&type=script&lang=ts&"
export * from "./SWarning.vue?vue&type=script&lang=ts&"
import style0 from "./SWarning.vue?vue&type=style&index=0&id=ad0d64d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "ad0d64d8",
  null
  
)

export default component.exports